import Form from "./form";
import { AttendanceLocal } from "../../../../../../../../../../../@types/attendance-local";
import { AttendanceLocalDepartment } from "../../../../../../../../../../../@types/attendance-local-department";
import { useAttendanceLocalDepartmentQueueCreate } from "../../../../../../../../../../../services/api-tansquery/attendance-local/department/queue/create";

type FormCreateProps = {
    departmentId: AttendanceLocalDepartment["id"];
    slug: AttendanceLocal["slug_unidade"];
    buttonTrigger?: React.ReactNode;
};

export default function FormCreate(props: FormCreateProps) {
    const mutation = useAttendanceLocalDepartmentQueueCreate();

    return (
        <Form
            {...props}
            mutation={mutation}
        />
    );
}
